import { initializeApp } from 'firebase/app';
import { getAnalytics, setAnalyticsCollectionEnabled, logEvent } from 'firebase/analytics';
import { getAuth } from 'firebase/auth';
import { getFirestore, initializeFirestore } from 'firebase/firestore';
import { getStorage } from 'firebase/storage';
import { getFunctions, connectFunctionsEmulator } from 'firebase/functions';
import get from 'lodash/get';

const config = {
  apiKey: process.env.REACT_APP_FIREBASE_APIKEY,
  authDomain: process.env.REACT_APP_FIREBASE_AUTHDOMAIN,
  databaseURL: process.env.REACT_APP_FIREBASE_DATABASEURL,
  projectId: process.env.REACT_APP_FIREBASE_PROJECTID,
  storageBucket: process.env.REACT_APP_FIREBASE_STORAGEBUCKET,
  messagingSenderId: process.env.REACT_APP_FIREBASE_MESSAGINGSENDERID,
  appId: process.env.REACT_APP_FIREBASE_APPID,
  measurementId: process.env.REACT_APP_FIREBASE_MEASUREMENT_ID,
};

class Firebase {
  constructor() {
    this.firebase = initializeApp(config);
    this._analytics = getAnalytics(this.firebase);
    this.analytics = () => {
      if (get(window, 'cookieconsent.consentDebugger.userConsent.acceptedLevels.tracking', true)) {
        setAnalyticsCollectionEnabled(this._analytics, true);
      } else {
        setAnalyticsCollectionEnabled(this._analytics, false);
      }
      return this._analytics;
    };
    this.logEvent = (message, eventParams) => {
      logEvent(this._analytics, message, eventParams);
    };
    this.auth = getAuth(this.firebase);

    initializeFirestore(this.firebase, {
      ignoreUndefinedProperties: true,
    });
    this.db = getFirestore(this.firebase);

    // this.db.enablePersistence({ synchronizeTabs: true }).then(() => {
    //   console.log("Woohoo! Multi-Tab Persistence!");
    // });
    this.storage = getStorage(this.firebase);
    if (process.env.REACT_APP_LOCAL_FUNCTIONS === '1') {
      console.info('Using functions emulator');
      this.functions = getFunctions(this.firebase, 'us-central1');
      connectFunctionsEmulator(this.functions, 'http://localhost', 5001);
    } else {
      this.functions = getFunctions(this.firebase, 'europe-west1');
    }
    if (process.env.REACT_APP_LOCAL_FIRESTORE === '1') {
      console.info('Using firestore emulator');
      // Note that some docs states you should use port 8081, but that causes CORS errors.
      // One must use the 8080 port.
      this.db.settings({
        host: '127.0.0.1:8080',
        ssl: false,
      });
    }
  }

  isInitialized() {
    return new Promise((resolve) => {
      this.auth.onAuthStateChanged(resolve);
    });
  }
}

const firebase = new Firebase();

export default firebase;
